import React from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FlatTabItem, FlatTab } from "@/components/FlatTab";
import { ROUTES } from "@/routes/paths";

export function NewInvite() {
  const { t } = useTranslation();

  const getActiveTab = () => {
    const path = location.pathname;
    if (
      path.includes(
        ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.SEND_INVITE ||
          ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.DETAILS,
      )
    )
      return ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.DETAILS;
    if (path.includes(ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.ROLE))
      return ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.ROLE;
    return ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.DETAILS;
  };

  const activeTab = getActiveTab();

  const tabItems: FlatTabItem[] = [
    {
      label: t("teamManagement.inviteForm.details.tab"),
      active: activeTab === ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.DETAILS,
      route: "sendInviteDetails",
    },
  ];

  const outletContext = {};

  return (
    <div className="min-h-screen bg-background">
      <div className="mb-4 flex w-full items-center pt-6 pr-6 pl-8">
        <h1 className="grow text-2xl font-semibold text-foreground">
          {t("teamManagement.invite")}
        </h1>
      </div>

      <div className="ml-8">
        <FlatTab items={tabItems} />
      </div>

      <div className="w-full border-b border-border"></div>

      <div className="px-8 pt-8">
        <Outlet context={outletContext} />
      </div>
    </div>
  );
}
